import type { IconNames } from "@smartsuite/icons";
import type { FunctionComponent } from "react";
import { StyledInfoButton } from "./InfoIconButtonStyle";
import { Icon } from "@smartsuite/react-ui/lib";

interface InfoIconButtonProps {
  iconName: IconNames;
  onClick?: () => void;
}

export const InfoIconButton: FunctionComponent<InfoIconButtonProps> = ({
  iconName,
  onClick,
}) => {
  return (
    <StyledInfoButton onClick={onClick} role="button">
      <Icon transition={true} color="currentColor" name={iconName} />
    </StyledInfoButton>
  );
};
